export default "__VITE_ASSET__C9CkBScs__"